const t = "af.filter-sidebar.show-paid-fonts-toggled", s = class s extends CustomEvent {
  constructor(o) {
    super(t, { detail: { showPaidFonts: o }, bubbles: !0, composed: !0 });
  }
};
s.EVENT_NAME = t;
let e = s;
export {
  t as EVENT_NAME,
  e as default
};
//# sourceMappingURL=ShowPaidFontsToggleEvent.js.map
